<template>
    <div class="widget accordion" :id="randomizeId">
        <h2>{{accordion.title}}</h2>
        <div class="card" v-for="acc in accordion.accordion_elements" :key="acc.index">
            <div class="card-header" :id="randomizeId+'aria'">
                <h5 class="mb-0" data-toggle="collapse" :data-target="'#collapse'+acc.id" aria-expanded="false" :aria-controls="'collapse'+randomizeId">
                    {{acc.question}}
                    <svg width="12" height="7">
                        <g clip-path="url(#clip_0)">
                            <path fill="rgb(74,74,74)" stroke="none" transform="matrix(-4.37114e-08 -1 1 -4.37114e-08 0.045166 6.95871)" d="M1.83754 5.65475L6.21162 1.28067C6.50479 0.987505 6.50479 0.512505 6.21162 0.219877C5.91845 -0.0732925 5.44345 -0.0732925 5.15082 0.219877L0.410862 4.95983C0.341414 4.99482 0.275678 5.03776 0.21789 5.09555C0.0641524 5.24929 -0.00688048 5.45286 0.000529517 5.65484C-0.00689243 5.8563 0.0636149 6.05987 0.21789 6.21413C0.275674 6.27192 0.34194 6.31486 0.410862 6.34985L5.15082 11.0903C5.44399 11.383 5.91899 11.383 6.21162 11.0903C6.50479 10.7972 6.50479 10.3222 6.21162 10.029L1.83754 5.65475Z"/>
                        </g>
                    </svg>
                </h5>
            </div>
            <div :id="'collapse'+acc.id" class="collapse" :aria-labelledby="randomizeId+'aria'" :data-parent="'#'+randomizeId">
                <div class="card-body" v-html="acc.answer"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'accordionWidget',
    props: ['data'],
    computed: {
        accordion(){
            return this.data
        },
        randomizeId: function() {
            return 'accordion'+Math.floor(Math.random() * 100) + 1
        }
    },
    data() {
        return {

        }
    },
    methods: {

    }
}

</script>